import { render, staticRenderFns } from "./BaseProgressCircular.vue?vue&type=template&id=035bbf80"
import script from "./BaseProgressCircular.vue?vue&type=script&lang=js"
export * from "./BaseProgressCircular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports